import React, {useState} from 'react';
import {Box} from '@mui/material';
import leylaVoila from '../../../../../assets/chat/leyla-boss/voila.png';

export function LeylaBossMoment({moment}) {
	const [assetFailed, setAssetFailed] = useState(false);
	if (moment !== 'voila' || assetFailed) return null;

	return (
		<Box
			component="img"
			src={leylaVoila}
			alt="Leyla Boss"
			onError={() => setAssetFailed(true)}
				sx={{
				display: 'block',
				width: {xs: 112, sm: 148},
				height: 'auto',
				maxHeight: {xs: 150, sm: 190},
				objectFit: 'contain',
				objectPosition: 'left bottom',
				bgcolor: '#faf9f6',
				borderRadius: 2,
				border: '1px solid rgba(0, 82, 70, 0.14)',
				mt: 0.75,
				ml: 1
			}}
		/>
	);
}
